import Model from '@/shared/orm/Model'
export default class Customer extends Model {
    dates() {
        return {
            blocked_at: 'YYYY-MM-DD',
            created_at: 'YYYY-MM-DD',
            deleted_at: 'YYYY-MM-DD',
        }
    }
    get blocked() {
        return this.blocked_at._isValid
    }
}
